import type { FC, PropsWithChildren } from 'react';
import { createContext, memo, useContext, useMemo, useState } from 'react';

interface IContext {
    /** Полноэкранный режим */
    isFull: boolean;
    /** Переключить полноэкранный режим */
    setIsFull: React.Dispatch<React.SetStateAction<boolean>>;
}

const Context = createContext<IContext>({ isFull: false, setIsFull: () => undefined });

/** Состояние полноэкранного режима */
export const useSizeStore = () => useContext(Context);

const SizeStore: FC<PropsWithChildren> = ({ children }) => {
    const [state, setState] = useState(false);

    const contextValue = useMemo<IContext>(() => {
        return { isFull: state, setIsFull: setState };
    }, [state]);

    return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

export default memo(SizeStore);
